import StatTable from "./StatTable";
export default StatTable;
